/* eslint-disable @typescript-eslint/ban-types */
import React, { FC, ReactFragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  Grid
} from '@material-ui/core';

interface ConfirmationDialogProps {
  title: string;
  description: string | ReactFragment | JSX.Element;
  open: boolean;
  handleClose: Function;
  handleAgree: Function | null;
  showCancel?: boolean;
  buttonText?: string;
  maxWidth?: 'lg' | 'md' | 'sm' | 'xl' | 'xs' | false;
  fullWidth?: boolean;
  variantTitle?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2';
}

const useStyles = makeStyles(() => ({
  button: {
    fontSize: '2.1rem'
  }
}));

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({ title, description, open, handleClose, handleAgree, showCancel, buttonText,
  maxWidth = false, fullWidth = false, variantTitle = 'h1' }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={() => handleClose()}
      fullWidth={fullWidth}
      maxWidth={maxWidth as 'lg' | 'md' | 'sm' | 'xl' | 'xs' | false}
    >
      <DialogTitle id="alert-dialog-slide-title">
        <Typography variant={variantTitle} color="textPrimary">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description" align='center'>
          {
            typeof description === 'string' ?
              <Typography variant="h4" color="textSecondary">
                {description}
              </Typography>
              :
              description
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container wrap="nowrap" justifyContent='flex-end'>
          <Grid item>
            {showCancel ?
              <Button onClick={() => handleClose()} color="primary" className={classes.button}>
                Cancel
              </Button>
              :
              <Button onClick={() => handleClose()} color="primary" className={classes.button}>
                Close
              </Button>
            }
          </Grid>
          <Grid item>
            {handleAgree ?
              <Button onClick={() => handleAgree()} color="primary" className={classes.button}>
                {buttonText}
              </Button>
              : ''}
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog >
  );
};

export default ConfirmationDialog;
